import { Injectable, Injector } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, ComponentType } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class OverlayService {
  private overlayRef: OverlayRef;

  overlays: { [key: string]: boolean } = {};

  constructor(private overlay: Overlay) {}

  isOpen(name: string) {
    return this.overlays[name];
  }

  open<T>(name: string, component: ComponentType<T>, data?: any) {
    if (this.isOpen(name)) {
      alert(`${name} already open`);
      return;
    }

    this.close();

    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically()
    });

    // Create injector with the data
    const injector = Injector.create({
      providers: [{ provide: 'OVERLAY_DATA', useValue: data }]
    });

    const overlayPortal = new ComponentPortal(component, null, injector);
    this.overlayRef.attach(overlayPortal);
    this.overlays[name] = true;
  }

  close() {
    Object.keys(this.overlays).forEach(name => {
      this.overlays[name] = false;
    });
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
  }
}
